<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ paymentLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout row wrap>
          <v-flex sm12>
            <v-text-field
              label="Name"
              v-model="pt.name"
              @input="$v.pt.name.$touch()"
              @blur="$v.pt.name.$touch()"
              :error-messages="nameErrors"
              :outlined="outlinedInputs"
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <div v-if="debug">{{pt}}</div>
  </v-content>
</template>

<script>
import {
  PAYMENT_TYPE_UPDATE_MUTATION,
  PAYMENT_TYPE_CREATE_MUTATION
} from "../../../../constants/graphql";
import { required } from "vuelidate/lib/validators";

export default {
  name: "PaymentTypeEditor",

  props: {
    paymentType: {
      type: Object,
      default: () => ({})
    },

    doSavePaymentType: {
      type: Boolean,
      default: false
    },

    paymentTypeEditorDialog: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      pt: { ...this.paymentType },
      debug: false
    };
  },

  methods: {
    savePaymentType() {
      this.$emit("onResetSave");
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let mutation =
          this.context == "edit"
            ? PAYMENT_TYPE_UPDATE_MUTATION
            : PAYMENT_TYPE_CREATE_MUTATION;
        this.$apollo
          .mutate({
            mutation: mutation,
            variables: {
              ...this.pt,
              paymentTypeId: this.pt.id
            }
          })
          .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
      }
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    }
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    paymentLabel() {
      return this.paymentType.id != null
        ? this.paymentType.name
        : "New Payment";
    },
    context() {
      return this.paymentType.id != null ? "edit" : "create";
    },
    nameErrors() {
      let errors = [];
      if (!this.$v.pt.name.$dirty) {
        return errors;
      }
      if (!this.$v.pt.name.required) {
        errors.push("Name is required.");
      }
      return errors;
    }
  },

  watch: {
    paymentType(data) {
      let paymentType = { ...data };
      delete paymentType.__typename;
      this.pt = paymentType;
    },
    paymentTypeEditorDialog(value) {
      if (!value) {
        this.pt = {};
        this.$v.$reset();
      }
    },
    doSavePaymentType(value) {
      if (value) {
        this.savePaymentType();
      }
    }
  },

  validations: {
    pt: {
      name: { required }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/currencies/PaymentTypeEditor.vue